{
  "WHATSAPP_TEMPLATE_MGMT": {
    "TITLE": "Șabloane",
    "DESCRIPTION": "Vizualizați șabloanele de mesaje sincronizate din inbox-urile dvs. WhatsApp. Pentru a crea sau edita un șablon, gestionați-l la furnizorul dvs.",
    "COUNT": "{n} șablon | {n} șabloane",
    "LEARN_MORE": "Află mai mult despre șabloanele WhatsApp",
    "SYNC_TEMPLATES": "Sincronizează șabloanele",
    "SYNC_SUCCESS": "Sincronizarea șabloanelor a început pentru toate inbox-urile WhatsApp. Actualizările pot dura câteva minute.",
    "PARTIAL_SYNC_ERROR": "Sincronizarea șabloanelor a început pentru unele inbox-uri WhatsApp, dar altele nu au putut fi sincronizate.",
    "SYNC_ERROR": "Nu s-a putut porni sincronizarea șabloanelor. Vă rugăm să încercați din nou.",
    "SEARCH_PLACEHOLDER": "Căutare după conținut sau nume...",
    "MANAGE_IN_META": "Gestionare în Meta",
    "LOADING": "Se încarcă șabloanele WhatsApp...",
    "EMPTY": "Nu s-au găsit șabloane WhatsApp.",
    "NO_RESULTS": "Niciun șablon nu corespunde filtrelor dvs.",
    "FETCH_ERROR": "Nu s-au putut încărca șabloanele WhatsApp. Vă rugăm să încercați din nou.",
    "PARTIAL_FETCH_ERROR": "Unele șabloane WhatsApp nu au putut fi încărcate. Vă rugăm să încercați din nou.",
    "LAST_SYNC_ATTEMPT": "Ultima încercare de sincronizare la {date}",
    "MORE_INBOXES": "+{n}",
    "STATUSES": {
      "UNSUBMITTED": "Netrimis pentru aprobare WhatsApp"
    },
    "FILTERS": {
      "ALL_INBOXES": "Toate inbox-urile",
      "ALL_LANGUAGES": "Toate limbile",
      "ALL_TYPES": "Toate tipurile"
    },
    "TYPES": {
      "TEXT": "Text",
      "IMAGE": "Imagine",
      "VIDEO": "Video",
      "DOCUMENT": "Document",
      "CALL_TO_ACTION": "Apel la acțiune",
      "COPY_CODE": "Copiază codul"
    },
    "PREVIEW": {
      "TITLE": "Previzualizare șablon",
      "DESCRIPTION": "Previzualizați cum apare acest șablon în WhatsApp.",
      "OPEN": "Previzualizează {name}",
      "CLOSE": "Închide previzualizarea",
      "DETAILS": "Detalii șablon",
      "STATUS": "Stare",
      "TYPE": "Tip de conținut",
      "CATEGORY": "Categorie",
      "LANGUAGE": "Limbă",
      "INBOXES": "Inbox-uri"
    }
  }
}
